import OriginInfoProductList from '@/data/originInfoProduct/view/list.vue'
import OriginInfoProductEditor from '@/data/originInfoProduct/view/editor.vue'

const list = {
  path: '/originInfoProduct',
  name: 'originInfoProduct-list',
  component: OriginInfoProductList
}
const creator = {
  path: '/originInfoProduct/creator',
  name: 'createOriginInfoProduct',
  component: OriginInfoProductEditor
}
const editor = {
  path: '/originInfoProduct/editor/:id(\\d+)',
  name: 'updateOriginInfoProduct',
  component: OriginInfoProductEditor
}

export default [list, creator, editor]
